












































































import {
  Component,
  Vue
} from "vue-property-decorator";
import { Getter } from 'vuex-class';
import { updatedAccountData, userData } from '@/types';

@Component
export default class Account extends Vue {
  public firstname: string = '';
  public lastname: string = '';
  public chargeAccount: number = 0;
  public showProfileData: boolean = false;

  @Getter public isSuccess: boolean;
  @Getter public user: object;

  showData(): void {
    this.showProfileData = !this.showProfileData
  }

  updateProfile(user: userData): void {
    const updatedData: updatedAccountData = {
      firstname: this.firstname || user.firstname,
      lastname: this.lastname || user.lastname,
      funds: Number(this.chargeAccount) + Number(user.funds),
      id: user.id
    }
    this.$store.dispatch("updateUser", updatedData)
  }
}
